import { generatePdf } from "../../utilities/PDFMakeUtil";
import pdfImage from "../../components/PDF/pdfImage";

export const pdfRPT114 = (dataReport_1, dataReport_2, setLoading, setDialogPDF) => {
    setLoading(true);

    const checkNull = (val) => {
        return val === null ? "" : val;
    };

    const container_1 = {
        layout: "noBorders",
        table: {
            widths: ["*", "20%"],
            style: "fontStyle",
            body: [
                [{ colSpan: 2, style: "fontStyle_center", text: "บริษัท/ห้างฯ  " + checkNull(dataReport_1[0].contractorName) }, {}],
                [{ colSpan: 2, style: "fontStyle_center", text: "ใบแจ้งขอปฏิบัติงาน และรายงานผลงานประจำวัน สัญญา/ข้อตกลงจ้าง  " + dataReport_1[0].contractNo }, {}],
                [
                    { style: "fontStyle_right", text: "วันที่ " },
                    { style: "fontStyle_left", text: dataReport_1[0].requestDate },
                ],
            ],
        },
    };

    const container_2 = {
        layout: "noBorders",
        table: {
            widths: ["20%", "*"],
            style: "fontStyle",
            body: [
                [{ colSpan: 2, style: "fontStyle", text: "เรียน นายช่างโครงการ ฯ / ผู้ควบคุมงาน" }, {}],
                [{}, { style: "fontStyle", text: "ด้วยบริษัท / ห้างฯ จะดำเนินการก่อสร้างวางท่อประปา ดังนี้" }],
                [{ colSpan: 2, margin: [0, 5, 0, 0], text: "" }, {}],
            ],
        },
    };

    // setdata tb 1
    const setDataTb_1 = () => {
        let arr = [];
        for (const iterator of dataReport_1) {
            arr.push([
                { style: { alignment: "center" }, text: iterator.routeName },
                { style: { alignment: "left" }, text: iterator.caseDesc },
                { style: { alignment: "center" }, text: iterator.requestQuantity },
                { style: { alignment: "center" }, text: iterator.locationDesc },
                { style: { alignment: "center" }, text: iterator.operateTime },
                { style: { alignment: "center" }, text: iterator.foreman },
            ]);
        }
        return arr;
    };

    // Table 1
    const container_3 = {
        table: {
            widths: ["15%", "*", "8%", "14%", "20%", "10%"],
            style: "fontStyle",
            body: [
                [
                    { rowSpan: 2, style: "tableHeader", text: "ลำดับ\nเส้นทาง" },
                    { style: "tableHeader", text: "งานที่จะดำเนินการวันนี้" },
                    { rowSpan: 2, style: "tableHeader", text: "ปริมาณ" },
                    { rowSpan: 2, style: "tableHeader", text: "บริเวณก่อสร้าง(กม.-กม.)" },
                    { rowSpan: 2, style: "tableHeader", text: "ช่วงเวลาปฏิบัติงาน" },
                    { rowSpan: 2, style: "tableHeader", text: "หัวหน้า" },
                ],
                [{}, { style: "tableHeader", text: "สถานที่ และลักษณะงาน" }, {}, {}, {}, {}],
                ...setDataTb_1(),
            ],
        },
    };

    // Table 2
    // setdata tb 2
    const setDataTb_2 = () => {
        let arr = [];
        for (const iterator of dataReport_2) {
            arr.push([
                { style: { alignment: "center" }, text: iterator.resultRouteNo },
                { style: { alignment: "left" }, text: iterator.resultCaseDesc },
                { style: { alignment: "center" }, text: iterator.resultQuantity },
                { style: { alignment: "center" }, text: iterator.resultLocation },
                { style: { alignment: "center" }, text: iterator.resultSize },
                { style: { alignment: "center" }, text: iterator.resultToday },
                { style: { alignment: "center" }, text: iterator.resultAccrue },
            ]);
        }
        return arr;
    };

    const container_4 = {
        margin: [0, 20, 0, 0],
        table: {
            widths: ["15%", "*", "8%", "14%", "11%", "8%", "10%"],
            style: "fontStyle",
            body: [
                [
                    { rowSpan: 2, style: "tableHeader", text: "ลำดับ\nเส้นทาง " },
                    { style: "tableHeader", text: "ผลงานวันที่  " + dataReport_1[0].requestDate },
                    { rowSpan: 2, style: "tableHeader", text: "ปริมาณ" },
                    { rowSpan: 2, style: "tableHeader", text: "บริเวณก่อสร้าง(กม.-กม.)" },
                    { colSpan: 3, style: "tableHeader", text: "ผลงาน" },
                    {},
                    {},
                ],
                [{}, { style: "tableHeader", text: "สถานที่ และลักษณะงาน" }, {}, {}, { style: "tableHeader", text: "ขนาด(มม.)" }, { style: "tableHeader", text: "วันนี้" }, { style: "tableHeader", text: "ถึงวันนี้" }],
                ...setDataTb_2(),
            ],
        },
    };

    // under table 2

    const container_6 = {
        margin: [0, 20, 0, 0],
        layout: "noBorders",
        table: {
            widths: ["50%", "50%"],
            style: "fontStyle",
            body: [
                [{ margin: [0, 0, 0, 20], colSpan: 2, style: "fontStyle_center", text: "จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติ และจัดส่งเจ้าหน้าที่ไปควบคุมงานดังกล่าว ต่อไป" }, {}],
                [{}, { style: "fontStyle_right", text: "กรรมการผู้จัดการ/หุ้นส่วนผู้จัดการ/วิศวกร/ผู้จัดการสนาม" }],
            ],
        },
    };

    // container checkbox
    const container_7 = {
        margin: [0, 20, 0, 0],
        table: {
            widths: ["5%", "*"],
            style: "fontStyle",
            body: [
                [{ colSpan: 2, style: "fontStyle", text: "ความเห็นของโครงการฯ /ผู้ควบคุมงาน" }, {}],
                [
                    { border: [1, 1, 0, 1], image: dataReport_1[0].flag1 === "Y" ? pdfImage.checkBox : pdfImage.unchecked, width: 15, height: 15 },
                    { border: [0, 1, 1, 1], style: "fontStyle", text: "เห็นชอบให้ดำเนินการลำดับ/เส้นทางที่" },
                ],
                [
                    { border: [1, 1, 0, 1], image: dataReport_1[0].flag2 === "Y" ? pdfImage.checkBox : pdfImage.unchecked, width: 15, height: 15 },
                    { border: [0, 1, 1, 1], style: "fontStyle", text: "ไม่อนุญาตให้ดำเนินการลำดับที่/เส้นทางที่" },
                ],
                [
                    { border: [1, 1, 0, 1], image: dataReport_1[0].flag3 === "Y" ? pdfImage.checkBox : pdfImage.unchecked, width: 15, height: 15 },
                    { border: [0, 1, 1, 1], style: "fontStyle", text: "อื่นๆ" },
                ],
                [{ colSpan: 2, style: "fontStyle", text: "บันทึกสั่งการ" }, {}],
                [{ colSpan: 2, style: "fontStyle", text: dataReport_2[0].remark === "" ? " " : dataReport_2[0].remark }, {}],
            ],
        },
    };

    // Footer
    const container_8 = {
        margin: [0, 50, 0, 0],
        layout: "noBorders",
        table: {
            widths: ["*"],
            style: "fontStyle",
            body: [[{ style: "fontStyle_right", text: "นายช่างโครงการฯ /ผู้ควบคุมงาน" }]],
        },
    };

    let sheet = {
        content: [container_1, container_2, container_3, container_4, container_6, container_7, container_8],
        styles: {
            header: {
                alignment: "left",
                fontSize: 16,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            fontStyle: {
                fontSize: 16,
            },
            fontStyle_center: {
                alignment: "center",
                fontSize: 16,
            },
            fontStyle_left: {
                alignment: "left",
                fontSize: 16,
            },
            fontStyle_right: {
                alignment: "right",
                fontSize: 16,
            },
            tableExample: {
                alignment: "right",
                margin: [0, 5, 0, 15],
            },
            tableHeader: {
                bold: true,
                fontSize: 16,
                color: "black",
                alignment: "center",
            },
            signature: {
                fontSize: 16,
                decoration: "underline",
                decorationStyle: "dotted",
                decorationColor: "black",
            },
            signature_dashed: {
                fontSize: 16,
                decoration: "underline",
                decorationStyle: "dashed",
                decorationColor: "black",
            },
            signature_wavy: {
                fontSize: 16,
                decoration: "underline",
                decorationStyle: "wavyF",
                decorationColor: "black",
            },
        },
        pageOrientation: "portrait",
        // pageOrientation: "landscape",
        pageSize: "A4",
        pageMargins: [30, 20, 30, 30],
        defaultStyle: {
            font: "THSarabunNew",
            alignment: "justify",
        },
    };

    // var content = {
    //     pageOrientation: "landscape",
    //     pageSize: "A4",
    //     content: [header(), data2],
    //     pageMargins: [15, 20, 40, 40],
    //     defaultStyle: {
    //         font: "THSarabunNew",
    //         alignment: "justify",
    //     },
    // };

    generatePdf(true, sheet, (dataUrl) => {
        setDialogPDF({ open: false, pdfURL: dataUrl });
        setLoading(false);
    });
};
